import type { GraviPageContext, SubmitTurnBody } from '@/api/gravitutor/types'
import { useLocation } from 'react-router-dom'

/**
 * Reads the user's current in-app location at render time. The component that
 * uses this re-renders on navigation (via useLocation), so the value is current
 * when the user sends a turn. Ported from S&D `GraviChat/pageContext.ts`.
 *
 * TODO(genapi): once `/gravitutor/*` is in the generated OpenAPI types, swap the
 * local `GraviPageContext`/`SubmitTurnBody` for the generated `components`
 * schemas (see `@/api/gravitutor/types`).
 */
export function usePageContext(): GraviPageContext {
  const location = useLocation()
  // document.title is set in a post-navigation effect, so it can lag location by
  // one render; harmless here since the user can't send before that cycle completes.
  const title =
    typeof document !== 'undefined' && document.title ? document.title : null
  return { path: location.pathname, title: title ?? undefined }
}

/**
 * Builds the submit-turn request body, attaching page context only when present
 * so an absent context leaves the payload identical to before.
 */
export function buildSubmitTurnBody(
  input: { text: string; attachments: SubmitTurnBody['attachments'] },
  context: GraviPageContext | null,
): SubmitTurnBody {
  return {
    text: input.text,
    attachments: input.attachments,
    ...(context ? { context } : {}),
  }
}
